// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { 
  initializeAuth, 
  indexedDBLocalPersistence, 
  browserLocalPersistence 
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyA6BFqgqX4myvP6u7iNUEQPcpios7xglQU",
  authDomain: "ipredict-21db5.firebaseapp.com",
  databaseURL: "https://ipredict-21db5-default-rtdb.firebaseio.com",
  projectId: "ipredict-21db5",
  storageBucket: "ipredict-21db5.firebasestorage.app",
  messagingSenderId: "1011487981190",
  appId: "1:1011487981190:web:55f31608705da4ca63db07",
  measurementId: "G-GWRQPEZE64"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence]
});

const db = getFirestore(app);
const rtdb = getDatabase(app);

export { app, analytics, auth, db, rtdb };